module.exports = __webpack_public_path__ + "media/images/iconSearch__errorRed-e14226824d5ae80e865312a8133a4beb.png";